import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import PersonActingOnBehalfOfAPatient from './PersonActingOnBehalfOfAPatient';

interface Props {
	patientId: string;
	isOpen: boolean;
	onClose: () => void;
	defaultValues: object;
	onSuccess: () => void;
}
const PatientProfilePersonActingOnBehalfOfAPatientModal: React.FC<Props> = ({
	patientId,
	isOpen,
	onClose,
	defaultValues,
	onSuccess,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header title='component.patientProfilePersonActingOnBehalfOfAPatient.title' />
			<Modal.Content contentScroll={true}>
				<PersonActingOnBehalfOfAPatient
					patientId={patientId}
					defaultValues={defaultValues}
					onSuccess={onSuccess}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default PatientProfilePersonActingOnBehalfOfAPatientModal;
